module.exports = __webpack_public_path__ + "static/img/service-6.05fc88c9.jpg";